export const loadState = name => {
  try {
    const state = localStorage.getItem(name);
    if (state === null) {
      return undefined;
    } else {
      return JSON.parse(state);
    }
  } catch (err) {
    return undefined;
  }
};

export const saveState = (name, state) => {
  try {
    const parsedState = JSON.stringify(state);
    localStorage.setItem(name, parsedState);
  } catch (err) {
    //ignore
  }
};

export const removeState = id => {
  try {
    localStorage.removeItem(id);
  } catch (err) {
    return undefined;
  }
};



// WEBPACK FOOTER //
// ./src/containers/localStorage.js